module.exports = __webpack_public_path__ + "static/trade-social2-cccd3a1264a0f0ac87e68f9f915916fb.jpg";